export default __webpack_public_path__ + "static/service1-393539fa18a8d0de44204f55bb77719f.png";